import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import Link from 'next/link';

import Alert from './Alert';

/**
 * Application main header
 * @title header title
 * @titleAction React element rendered next to title (optional)
 * @backButton object { text: string, path: string } (optional)
 * @actionButton object { text: string, path: string (optional), ...otherButtonParams } (optional)
 * @tags list of strings with tag names (optional)
 * @customAction React element (optional)
 */
class MainHeader extends React.Component {
  /**
   * @param {string} type
   * @param {any} value
   */
  onValueChange = (type, value) => {
    this.setState(
      { [type]: value },
      // @ts-ignore
      () => this.request()
    );
  }

  /**
   * @param {string[]} tags
   */
  renderTags = (tags) => {
    const compressedTags = tags.slice(0, 2);
    if (tags.length > 2) compressedTags.push(`+${tags.length - 2}`);
    return (
      <div className="tag-list header">{compressedTags.map((tag) => <span key={tag}>{tag}</span>)}</div>
    );
  }

  /**
   * @param {{
   *  type: string,
   *  text: string,
   *  onClose: () => null
   * }} alert
   */
  renderAlert = (alert) => (
    <Alert
      type={alert.type}
      key={alert.type}
      text={alert.text}
      visibleTime={3000}
      onClose={alert.onClose}
      close
    />
  )

  render() {
    const {
      title, titleParams, backButton, actionButton, tags, alert, customAction, footer, customActionSecond, titleAction = null, subtitle
    } = this.props;

    return (
      <div style={{ marginLeft: 60 }}>
        <div className="main-header">
          <div className="content">
            {backButton && (
              <Link href={backButton.path}>
                <a>
                  <Icon className="angle left" as={null} />
                  {backButton.text}
                </a>
              </Link>
            )}

            <div className="container">
              <div className="title">
                <Popup
                  content={title}
                  trigger={(<h1 {...titleParams}>{title}</h1>)}
                  position="bottom left"
                />
                {titleAction}
                {subtitle}
              </div>

              <div className="content right">
                <div style={{ display: 'flex' }}>
                  {actionButton && (actionButton.path
                    ? (
                      <Link href={actionButton.path}>
                        <button type="button" {...actionButton}>{actionButton.text}</button>
                      </Link>
                    ) : actionButton.component ? actionButton.component : <button type="button" {...actionButton}>{actionButton.text}</button>)}
                </div>
                {customAction}
                {customActionSecond}
              </div>
            </div>
            {tags && this.renderTags(tags)}
          </div>
          <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
            {alert && this.renderAlert(alert)}
          </div>
        </div>
        {footer}
      </div>
    );
  }
}

export default MainHeader;
